import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {GameInfo} from "../../../games/game-info";
import {Nullable, NullableNumber} from "../../../../../common/types/nullable-types";
import {AdhocArenaGameFilter} from "../filters/adhoc-arena-game-filter";
import {CompanyFilterDefinitions} from "../../filters-definitions/company/company.filter-definitions";
import { computed, makeObservable } from "mobx";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {AND} from "../../evaluators/and-game-filters-evaluator";
import {CategoryDefinitionId} from "../../filters-categories-definitions/filter-category-definition.interface";
import {
    GameVendorFiltersCategoryDefinition
} from "../../filters-categories-definitions/game-vendor.filters-category-definition";
import {IArenaGameFilter} from "../filters/arena-game-filter.interface";

export class AdhocArenaGamesFiltersCategory implements IArenaGameFiltersCategory {
    constructor(private readonly services: IServiceFactoryExtended) {
        makeObservable(this);
    }

    readonly id: CategoryDefinitionId = 'adHoc';
    readonly title: string = 'Ad hoc filters';
    readonly gamesCount: NullableNumber = null;


    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {

        if(this.availableFilters.length === 0) {
            return ApplyGameFilterResult.NotApplicable;
        }

        return AND(...this.availableFilters).applyFilter(gameInfo);
    }


    isGameIncludedInThisCategory(gameInfo: GameInfo): boolean {
        return this.applyFilter(gameInfo) === ApplyGameFilterResult.IncludeGame;
    }

    @computed
    get availableFilters(): AdhocArenaGameFilter[] {
        return this._createDynamicFilters();
    }

    get allAppliedFiltersAndSubFilters(): IArenaGameFilter[] {
        return this.availableFilters.filter(f => f.isApplied);
    }

    private _createDynamicFilters(): AdhocArenaGameFilter[] {
        const result: AdhocArenaGameFilter[] = [];



        const currentArenaFiltersConfigurations = this.services.arenas.getCurrentArena().filtersConfigurationMap;

        for(let appliedFilterId of this.services.gamesFilter.currentAppliedFiltersIds) {
            if(!currentArenaFiltersConfigurations[appliedFilterId]) {
                const dynamicFilterDefinition = this._createDynamicFilterById(appliedFilterId);
                if(dynamicFilterDefinition) {
                    result.push(dynamicFilterDefinition);
                }
            }
        }

        return result;
    }

    private _createDynamicFilterById(filterId: string): Nullable<AdhocArenaGameFilter> {
        const parts = filterId.split('_');
        if(parts.length < 2) {
            return null;
        }

        switch (parts[0]) {
            case 'vendor':
                const vendorsCategory = new GameVendorFiltersCategoryDefinition(this.services);
                const filter = vendorsCategory.getAllPreferredVendorsFilters().find(f => f.id === filterId) ?? null;
                if(filter) {
                    return new AdhocArenaGameFilter(filter, this.services)
                } else {
                    return null;
                }

            case 'company':
                return new AdhocArenaGameFilter(new CompanyFilterDefinitions(filterId, parts[1]), this.services);
            default:
                return null;

        }
    }

    get isMultiSelect(): boolean {
        return false;
    }
}